import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import IconButton from 'apollo-react/components/IconButton';
import Table from 'apollo-react/components/Table';
import Pencil from 'apollo-react-icons/Pencil';
import Plus from 'apollo-react-icons/Plus';
import React, { useState } from 'react';

import { PropertyComponentModal } from './PropertyComponentModal/PropertyComponentModal';
import { useFormSelector } from '../../../custom-hooks';
import { DATASOURCE_TYPE_PREDEFINED } from '../../constants/editor.constants';
import {
  getDataSources,
  getDataSourcesList,
  getOriginalDataSources,
} from '../../selectors/common.selectors';
import { difference } from '../../utils/editor.utils';

const useStyles = makeStyles({
  gridWrapper: {
    '& div table[class*="MuiTable-root"]': {
      overflowX: 'hidden',
      border: 'solid 1px #e9e9e9',
    },
  },
  dsChanges: {
    '&  div[class*="MuiToolbar-root"]': {
      border: '1px solid orange',
    },
  },
});

const ActionCell = ({ row }) => {
  const {
    setOpenModal,
    setCurrentModal,
    setDataSourceEditAction,
    setSelectedDataSource,
    dataSourceKey,
  } = row;
  return (
    <div style={{ paddingTop: 10 }}>
      <IconButton
        onClick={() => {
          setSelectedDataSource(dataSourceKey);
          setDataSourceEditAction('edit');
          setCurrentModal('dataSourceKey');
          setOpenModal(true);
        }}
      >
        <Pencil />
      </IconButton>
    </div>
  );
};

const columnsDataSources = [
  {
    header: 'Data Source Name',
    accessor: 'dataSourceKey',
  },
  {
    header: 'Data LookUp Type',
    accessor: 'dataSourceTypeStr',
  },
  {
    header: 'Data Object',
    accessor: 'dataSourceName',
  },
  {
    accessor: 'action',
    customCell: ActionCell,
  },
];

const FormModelDataSourcesTable = ({ controlId, label }) => {
  const classes = useStyles();
  const dataSourcesList = useFormSelector(getDataSourcesList) ?? [];
  const dataSources = useFormSelector(getDataSources);
  const originalDataSources = useFormSelector(getOriginalDataSources);

  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState('');
  const [dataSourceEditAction, setDataSourceEditAction] = useState('new');
  const [selectedDataSource, setSelectedDataSource] = useState('');

  const hasDataSourcesChanges = originalDataSources
    ? difference(dataSources, originalDataSources)
    : {};
  const formDSChanges =
    Object.keys(hasDataSourcesChanges).length > 0
      ? false
      : Object.keys(dataSources) >= Object.keys(originalDataSources);

  const CustomHeaderDataSource = () => (
    <div>
      <IconButton
        variant="text"
        onClick={() => {
          setCurrentModal('dataSourceKey');
          setDataSourceEditAction('new');
          setOpenModal(true);
        }}
      >
        <Plus />
      </IconButton>
    </div>
  );

  return (
    <Grid
      container
      spacing={2}
      classes={{
        root: classes.gridWrapper,
      }}
    >
      <Grid item xs={12}>
        <Table
          title="Data Sources"
          columns={columnsDataSources}
          rows={dataSourcesList
            .filter((dataSource) => dataSource.dataSourceType !== DATASOURCE_TYPE_PREDEFINED)
            .map((dataSource) => ({
              ...dataSource,
              setOpenModal,
              setCurrentModal,
              setDataSourceEditAction,
              setSelectedDataSource,
            }))}
          classes={{
            root: !formDSChanges ? classes.dsChanges : {},
          }}
          hidePagination
          CustomHeader={CustomHeaderDataSource}
        />
      </Grid>
      {openModal && (
        <PropertyComponentModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          controlId={controlId}
          name={currentModal}
          label={label}
          dataSourceFromStore={selectedDataSource}
          dataSourceEditAction={dataSourceEditAction}
          setDataSourceEditAction={setDataSourceEditAction}
          isDataSourceViewer={true}
        ></PropertyComponentModal>
      )}
    </Grid>
  );
};

export default FormModelDataSourcesTable;
